import { BaseMarkerFactory } from "../../../../_shared/interfaces/maps/base-marker-factory";

export class FuelChangesMarkerFactory extends BaseMarkerFactory {
  protected override createMarkerDiv(data: any): HTMLDivElement {
    const isLoss = String(data.type).toLowerCase() === 'loss';
    const isFillUp = String(data.type).toLowerCase() === 'fill-up';
    const color = isLoss ? '#FFA500' : '#00A65A';

    const markerDiv = document.createElement('div');
    markerDiv.dataset['type'] = data.type;
    markerDiv.style.width = '24px';
    markerDiv.style.height = '24px';

    if (isLoss || isFillUp) {
      markerDiv.style.setProperty('--cluster-color', color);
      markerDiv.className = "marker-pulsate";
    }
    markerDiv.innerHTML = `
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.660156 12.9648C0.660156 6.33743 6.03274 0.964844 12.6602 0.964844V0.964844C19.2876 0.964844 24.6602 6.33743 24.6602 12.9648V12.9648C24.6602 19.5923 19.2876 24.9648 12.6602 24.9648V24.9648C6.03274 24.9648 0.660156 19.5923 0.660156 12.9648V12.9648Z" fill="${color}"/>
        <path d="M12.6608 16.2979L13.3275 14.9645L13.3275 11.5365C14.4748 11.2385 15.3275 10.2032 15.3275 8.96452C15.3275 7.49385 14.1315 6.29785 12.6608 6.29785C11.1901 6.29785 9.99414 7.49385 9.99414 8.96452C9.99414 10.2032 10.8468 11.2385 11.9941 11.5365L11.9941 14.9645L12.6608 16.2979ZM11.3275 8.96452C11.3275 8.22919 11.9255 7.63119 12.6608 7.63119C13.3961 7.63119 13.9941 8.22919 13.9941 8.96452C13.9941 9.69985 13.3961 10.2979 12.6608 10.2979C11.9255 10.2979 11.3275 9.69985 11.3275 8.96452Z" fill="white"/>
        <path d="M15.5055 12.0065L15.1501 13.2919C16.8775 13.7692 17.9941 14.6872 17.9941 15.6312C17.9941 16.8925 15.8041 18.2979 12.6608 18.2979C9.51747 18.2979 7.32747 16.8925 7.32747 15.6312C7.32747 14.6872 8.44414 13.7692 10.1721 13.2912L9.81681 12.0059C7.45881 12.6579 5.99414 14.0465 5.99414 15.6312C5.99414 17.8739 8.92281 19.6312 12.6608 19.6312C16.3988 19.6312 19.3275 17.8739 19.3275 15.6312C19.3275 14.0465 17.8628 12.6579 15.5055 12.0065Z" fill="white"/>
      </svg>
    `;

    return markerDiv;
  }

  protected override createTitle(data: any): string {
    return `${data.vehicle} - ${data.location}`;
  }
}